"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var http_1 = require("@angular/common/http");
var Observable_1 = require("rxjs/Observable");
var find_http_error_1 = require("../error/find-http-error");
var ProvidedServiceService = /** @class */ (function () {
    function ProvidedServiceService(_http) {
        this._http = _http;
        this.FIND_ALL = ProvidedServiceService.PROVIDED_SERVICE_END_POINT + '/findAll';
    }
    ProvidedServiceService.prototype.findAll = function () {
        return this._http.get(this.FIND_ALL)
            .map(function (res) { return res; })
            .catch(function (error) { return Observable_1.Observable.throw(new find_http_error_1.FindHttpError(error._body)); });
    };
    ProvidedServiceService.ctorParameters = function () { return [{ type: http_1.HttpClient }]; };
    ProvidedServiceService.PROVIDED_SERVICE_END_POINT = '/providedService';
    return ProvidedServiceService;
}());
exports.ProvidedServiceService = ProvidedServiceService;
//# sourceMappingURL=provided-service.service.js.map


// WEBPACK FOOTER //
// provided-service.service.js